const Actions = {
	SET_YEAR: 'SET_YEAR',
	SET_APPOINTMENTS: 'SET_APPOINTMENTS',
	SET_CONTRACTS: 'SET_CONTRACTS',
	SET_CURRENT_CONTRACT: 'SET_CURRENT_CONTRACT',
	SET_TEAM: 'SET_TEAM',
	SET_APPOINTEE: 'SET_APPOINTEE',
	CHECKED_PDF: 'CHECKED_PDF',
	CLOSED_PDF: 'CLOSED_PDF',
	VALIDATE_SUCCESS: 'VALIDATE_SUCCESS',
	VALIDATE_PARTIAL_SUCCESS: 'VALIDATE_PARTIAL_SUCCESS',
	VALIDATE_FAIL: 'VALIDATE_FAIL',
	VIEW_PDF: 'VIEW_PDF',
	VIEW_TANDC: 'VIEW_TANDC',
	CHECK: 'CHECK'
};

export default Actions;
